import { Component } from '@angular/core';

@Component({
  selector: 'app-thead-plan',
  templateUrl: './thead-plan.component.html',
  styleUrls: ['./thead-plan.component.scss', './../program.component.scss']
})
export class TheadPlanComponent  {


}
